import { render, staticRenderFns } from "./MKoreanLiveCartNew.vue?vue&type=template&id=02f8d0d3&scoped=true"
import script from "./MKoreanLiveCartNew.vue?vue&type=script&lang=js"
export * from "./MKoreanLiveCartNew.vue?vue&type=script&lang=js"
import style0 from "./MKoreanLiveCartNew.vue?vue&type=style&index=0&id=02f8d0d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f8d0d3",
  null
  
)

export default component.exports